<template>
  <el-select v-model="value" placeholder="请选择公司" clearable @change="changeCompany"
     filterable :filter-method="filterHandle">
    <el-option v-for="item in options" :key="item.companyId" :label="item.companyName" :value="item.companyId">
    </el-option>
  </el-select>
</template>

<script>
import { mapState } from 'vuex'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: ['value'],
  data () {
    return {
      options: []
    }
  },
  computed: {
    ...mapState(['companyOption'])
  },
  mounted () {
    setTimeout(() => {
      this.options = this.companyOption
    }, 3000);
  },
  methods: {
    changeCompany (val) {
      this.$emit('change', val)
    },
    filterHandle (query) {
      if (query) {
        const pattern = new RegExp(query.split('').join('.*'), 'i');
        this.options = this.companyOption.filter(item => {
          return pattern.test(item.companyName + item.companyId);
        })
      }else {
        this.options = this.companyOption
      }
    }
  }
}

</script>

<style lang="scss" scoped>

</style>
